import { capitalize } from "@/utils";
import { cn } from "../lib/cn";
import type { StatusOption } from "../types/global.types";

interface StatusTagProps {
  value: string;
  config: StatusOption[];
  shouldCapitalize?: boolean;
}

const StatusTag = ({
  value,
  config,
  shouldCapitalize = true,
}: StatusTagProps) => {
  const matched = config.find(
    (s) => String(s.value).toLowerCase() === String(value).toLowerCase(),
  );
  if (!matched) return <span>-</span>;
  return (
    <span className={cn("status", matched.className)}>
      {shouldCapitalize ? capitalize(matched.label) : matched.label}
    </span>
  );
};

export default StatusTag;
